import { SchemaFieldProperty } from './schema-field-property';

/* istanbul ignore file */
export class FieldProperty extends SchemaFieldProperty {
    id: string;
}
